import { createStore } from "redux";
import reducerPrincipal from "./../redux/reducers/index"

export const store = createStore(reducerPrincipal);